import { client } from './client';
import { EmployeeShortInfo, SortDirection, StatusResponse } from './types';

export interface SendFeedbackParams {
  typeId: number;
  message: string;
}

export interface SendFeedbackResponse extends StatusResponse {
  feedbackId: number;
}

export const sendFeedback = async (
  params: SendFeedbackParams,
): Promise<SendFeedbackResponse> => {
  try {
    const response = await client.post<SendFeedbackResponse>(
      '/api/v2/feedbacks',
      params,
    );
    return response.data;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export const acceptFeedback = async (feedbackId: number): Promise<void> => {
  try {
    await client.post('/api/v2/feedbacks/AcceptFeedback', {
      feedbackId,
    });
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export const completeFeedback = async (
  feedbackId: number,
  completedComment: string,
): Promise<void> => {
  try {
    await client.post('/api/v2/feedbacks/CompleteFeedback', {
      feedbackId,
      completedComment,
    });
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};

export enum FeedbackType {
  Question = 1,
  Proposal = 2,
  Issue = 3,
}

export enum FeedbackStatus {
  Created = 1,
  Accepted = 2,
  Completed = 3,
}

export interface FeedbackData {
  id: number;
  typeId: FeedbackType;
  message: string;
  status: FeedbackStatus;
  created: string;
  createdBy: EmployeeShortInfo;
  accepted: string | null;
  acceptedBy: EmployeeShortInfo | null;
  completed: string | null;
  completedBy: EmployeeShortInfo | null;
  completedComment: string | null;
}

export interface FindFeedbacksParams {
  pageSize: number;
  pageNumber: number;
  typeId: number | null;
  status: FeedbackStatus[];
  sortDirection: SortDirection;
}

export interface FindFeedbacksResponse {
  totalRows: number;
  pageSize: number;
  pageNumber: number;
  pageItems: FeedbackData[];
}

export const findFeedbacks = async (
  params: FindFeedbacksParams,
): Promise<FindFeedbacksResponse> => {
  const { status, ...rest } = params;
  const statusQuery = status.map(s => `status=${s}`).join('&');
  const query = statusQuery ? `?${statusQuery}` : '';

  try {
    const response = await client.get<FindFeedbacksResponse>(
      `/api/v2/feedbacks/FindFeedbacks${query}`,
      {
        params: rest,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Unable to call server.', error);
    throw error;
  }
};
